export default "__VITE_ASSET___$1isTjo__"